const NotificationAction = {
  ADD: 'add',
  REMOVE: 'remove',
};

export default NotificationAction;
